export const projectConfig = {
  port: 4700,
  host: 'localhost',
};
